module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAwIDIwMCI+PHN0eWxlPi5zdDB7b3BhY2l0eTowLjE7ZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7ZmlsbDojNTJCM0U1O308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xMDAgMGM1NS4yIDAgMTAwIDQ0LjggMTAwIDEwMHMtNDQuOCAxMDAtMTAwIDEwMFMwIDE1NS4zIDAgMTAwIDQ0LjggMCAxMDAgMHoiLz48cGF0aCBpZD0iWE1MSURfNzlfIiBjbGFzcz0ic3QwIiBkPSJNMTAwIDQyLjVjMzEuOCAwIDU3LjUgMjUuOCA1Ny41IDU3LjVzLTI1LjcgNTcuNS01Ny41IDU3LjUtNTcuNS0yNS43LTU3LjUtNTcuNVM2OC4yIDQyLjUgMTAwIDQyLjV6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/images/circle2.svg
// module id = 498
// module chunks = 54681204059826